<template>
  <div class="demo-code">
    <div class="demo-block"><slot></slot></div>
    <h4 class="demo-title">
      <span>{{ title }}</span>
      <k-icon
        v-if="codeHeight > height"
        @click="expanded = !expanded"
        type="code"
        size="22"
      />
    </h4>
    <p v-if="desc" class="demo-desc">
      {{ desc }}
    </p>

    <pre
      class="hljs"
      :class="{ expanded: expanded || codeHeight < height }"
      :style="{
        height: (expanded ? codeHeight : Math.min(height, codeHeight)) + 'px'
      }"
      v-if="code"
      v-highlightjs
    ><code ref="hljs" class="vue hljs xml">{{code}}</code>
    <k-icon v-if="codeHeight>500" @click="expanded = !expanded" type="code" size="22" />
    </pre>
  </div>
</template>
<script>
/**
 * 代码展开说明：
 * 代码块高度小于200像素，默认为展开状态，不现实切换图标
 * 代码块高度超过500像素，在代码块展开的情况下，右下角显示切换按钮
 *
 */
export default {
  props: {
    title: String,
    desc: String,
    code: String
  },
  data() {
    return {
      expanded: false,
      height: 200,
      codeHeight: 90
    };
  },
  mounted() {
    if (this.code) {
      this.codeHeight = this.$refs.hljs.clientHeight || 200;
    }
  }
};
</script>
<style lang="less" scoped>
.demo-code {
  overflow: hidden;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 16px;
  background-image: linear-gradient(#efefef 2px, transparent 0),
    linear-gradient(90deg, #efefef 2px, transparent 0),
    linear-gradient(#efefef 1px, transparent 0),
    linear-gradient(90deg, #efefef 1px, transparent 0);
  background-size: 75px 75px, 75px 75px, 15px 15px, 15px 15px;
  box-shadow: inset 0 0 6px 1px #e0e0e0;
  transition: box-shadow 0.2s linear;
  &:hover {
    box-shadow: inset 0 0 0px 2px #fff;
  }
  .demo-title {
    margin: 0;
    display: table;
    white-space: nowrap;
    text-align: center;
    background: 0 0;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.5;
    height: 1px;
    width: 100%;
    min-width: 100%;
    vertical-align: middle;
    position: relative;
    top: -0.06em;
    clear: both;
    padding: 0;
    span {
      display: inline-block;
      padding: 0 10px;
      font-size: 14px;
      color: #333;
    }

    &::before,
    &::after {
      content: "";
      display: table-cell;
      position: relative;
      top: 50%;
      width: 50%;
      border-top: 1px solid #ccc;
      transform: translateY(50%);
    }

    &::before {
      top: 50%;
      width: 5%;
    }
    &::after {
      top: 50%;
      width: 95%;
    }

    .k-icon {
      position: absolute;
      right: -1px;
      top: 2px;
      z-index: 1;
      background-color: #f7f7f7;
      cursor: pointer;
      border: 1px solid #ccc;
      padding: 0 2px;
    }
  }
  .demo-desc {
    font-size: 14px;
    padding: 0 16px;
    color: #666;
  }
  .demo-block {
    padding: 16px 24px;

    .purity-bg {
      background: rgb(247, 247, 247);
      padding: 20px 50px;
      & > p {
        color: #999;
      }
    }
  }
  pre.hljs {
    position: relative;
    transition: height 0.2s linear;
    overflow-y: hidden;
    &::after {
      display: block;
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      bottom: 0px;
      left: 0px;
      z-index: 1;
      background-image: linear-gradient(0deg, #f1f1f1 10%, transparent 80%);
    }

    .k-icon {
      display: none;
    }

    &.expanded {
      &::after {
        display: none;
      }
      .k-icon {
        cursor: pointer;
        display: block;
        z-index: 2;
        font-size: 22px;
        position: absolute;
        padding: 0 2px;
        right: 0;
        bottom: 0;
        background-color: #f7f7f7;
        border-top: 1px solid #ccc;
        border-left: 1px solid #ccc;
      }
    }
  }
}
</style>
<style>
/* 示例代码高亮 */
/* Base16 Atelier Lakeside Light - Theme */
/* by Bram de Haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside) */
/* Original Base16 color scheme by Chris Kempson (https://github.com/chriskempson/base16) */

/* Atelier-Lakeside Comment */
.hljs {
  display: block;
  overflow-x: auto;
  padding: 0;
  margin: 0;
  color: #383a42;
}

.hljs-comment,
.hljs-quote {
  color: #a0a1a7;
  font-style: italic;
}

.hljs-doctag,
.hljs-keyword,
.hljs-formula {
  color: #e96900;
}

.hljs-section,
.hljs-name,
.hljs-selector-tag,
.hljs-deletion,
.hljs-subst {
  color: #3e76f6;
}

.hljs-literal {
  color: #0184bb;
}

.hljs-string,
.hljs-regexp,
.hljs-addition,
.hljs-attribute,
.hljs-meta-string {
  color: #50a14f;
}

.hljs-built_in,
.hljs-class .hljs-title {
  color: #c18401;
}

.hljs-attr,
.hljs-variable,
.hljs-template-variable,
.hljs-type,
.hljs-selector-class,
.hljs-selector-attr,
.hljs-selector-pseudo,
.hljs-number {
  color: #e96900;
}

.hljs-symbol,
.hljs-bullet,
.hljs-link,
.hljs-meta,
.hljs-selector-id,
.hljs-title {
  color: #4078f2;
}

.hljs-emphasis {
  font-style: italic;
}

.hljs-strong {
  font-weight: bold;
}

.hljs-link {
  text-decoration: underline;
}
</style>
